export const dateFormats = {
    start_date: "MM-DD-YYYY",
    start_date_api: "YYYY-MM-DD",
    end_date: "MM-DD-YYYY",
    end_date_api: "YYYY-MM-DD",
  };